import { Body, breakpoints, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    margin: 32px 72px;
    margin-top: 8px;

    ${breakpoints.med} {
        margin: 32px 32px;
        margin-top: 8px;
    }

    ${breakpoints.xsmall} {
        text-align: center;
        margin: 16px 16px;
        margin-top: 8px;
    }

    span {
        text-align: center;
    }
`

const SubtitleContainer = styled.div`
    max-width: 700px;
`

export const PageTitle: React.FC<{ subtitle?: string }> = ({ children, subtitle }) => {
    return (
        <TitleContainer>
            <Body.Bold size={28}>{children}</Body.Bold>
            {subtitle && (
                <SubtitleContainer>
                    <Spacer height={8} />
                    <Body.Med size={16} secondary align="center">
                        {subtitle}
                    </Body.Med>
                </SubtitleContainer>
            )}
        </TitleContainer>
    )
}
